import { Component, Input, OnChanges } from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexFill,
  ApexLegend,
  ApexPlotOptions,
  ApexTitleSubtitle,
  ApexTooltip,
  ApexXAxis,
  ApexYAxis,
} from "ng-apexcharts";

import { SharedService } from '@app/core';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  markers: any; //ApexMarkers;
  stroke: any; //ApexStroke;
  yaxis: ApexYAxis | ApexYAxis[];
  dataLabels: ApexDataLabels;
  title: ApexTitleSubtitle;
  legend: ApexLegend;
  fill: ApexFill;
  tooltip: ApexTooltip;
  colors: string[];
  plotOptions: ApexPlotOptions;
  labels: any;
};
@Component({
  selector: 'app-mixed-chart',
  templateUrl: './mixed.component.html',
  styleUrls: ['./mixed.component.scss']
})
export class MixedChartComponent implements OnChanges {
  @Input() series: ApexAxisChartSeries;
  @Input() categories: string[];
  @Input() yAxisRange: { min: number, max: number }[];
  @Input() isProduct: boolean;
  @Input() isXCapitalized: boolean = true; // Default value is true
  @Input() customTooltip?: ((options: any) => any) | ((options: any) => any)[];

  chartOptions: Partial<ChartOptions>;

  constructor(private sharedService: SharedService) { }

  ngOnChanges() {
    this.yAxisRange = this.yAxisRange.map(range => {
      range.max = range.max - range.min < 10 ? range.min + 10 : range.max;

      return {
        min: this.sharedService.roundDown(range.min),
        max: this.sharedService.roundUp(range.max)
      }
    });
    let yAxis: any[] = [{
      min: this.yAxisRange?.[0].min,
      max: this.yAxisRange?.[0].max,
      axisTicks: {
        show: true
      },
      axisBorder: {
        show: true,
        color: "#0b84a5"
      },
      labels: {
        formatter: (value: number) => this.sharedService.formatNumber(value, true)
      },
      title: {
        text: "Amount (₹)",
        style: {
          color: "#0b84a5"
        }
      }
    }];

    if (!this.isProduct) {
      yAxis = [
        ...yAxis,
        {
          opposite: true,
          min: this.yAxisRange?.[1]?.min,
          max: this.yAxisRange?.[1]?.max,
          axisTicks: {
            show: false
          },
          axisBorder: {
            show: false,
            color: "#fda777"
          },
          labels: {
            formatter: (value: number) => this.sharedService.formatNumber(value, true),
            show: false
          },
          title: {
            style: {
              color: "#fda777"
            }
          }
        },
        {
          opposite: true,
          axisTicks: {
            show: true
          },
          axisBorder: {
            show: true,
            color: "#4682b4"
          },
          labels: {
            formatter: (value: number) => this.sharedService.formatNumber(value)
          },
          title: {
            text: "Invoices Reviewed",
            style: {
              color: "#4682b4"
            }
          }
        }
      ];
    }

    const tooltip = {
      enabled: true
    };

    if (this.customTooltip) {
      tooltip['custom'] = this.customTooltip;
      tooltip['followCursor'] = true;
      tooltip['fillSeriesColor'] = true;
      tooltip['theme'] = 'light';
    }

    this.chartOptions = {
      series: this.series,
      // colors: ['#00bfff', '#fda777', '#4682b4'],
      colors: ['#D97983', '#EBB901', '#339DE1'],
      chart: {
        height: 350,
        type: "line",
        stacked: false,
        redrawOnWindowResize: true,
        zoom: {
          enabled: true,
          type: 'x',
          autoScaleYaxis: false,
        },
        toolbar: {
          show: true,
          tools: {
            download: false, // Set to false to hide the download option
          },
        }
      },
      plotOptions: {
        bar: {
          borderRadius: 4
        },
      },
      tooltip,
      dataLabels: {
        enabled: false
      },
      stroke: {
        width: [1, 1, 2],
        curve: "smooth"
      },
      xaxis: {
        type: 'category',
        offsetY: 0,
        categories: this.isXCapitalized ? this.categories.map((item) => this.sharedService.capitalize(item)) : this.categories,
        labels: {
          trim: true,
          rotate: -45
        }
      },
      yaxis: yAxis,
      legend: {
        horizontalAlign: "center",
        // offsetX: 40,
        offsetY: 8,
        showForSingleSeries: true
      }
    };
  }
}